import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';

import './UserMenu.less';

const UserMenuContent = ({ signOutAction }) => (
  <div className="user-menu-content">
    <Button icon="stop" onClick={signOutAction}>Sign out</Button>
  </div>
);

UserMenuContent.propTypes = {
  signOutAction: PropTypes.func.isRequired,
};


export default UserMenuContent;



// WEBPACK FOOTER //
// ./src/components/Layout/Main/UserMenu/UserMenuContent.js